import React from 'react';
import { Progress } from 'tea-component';
import './index.scss';

interface IMetricProgressProps {
  /** 最大值，用于计算百分比 */
  biggest: number;
  /** 当前值 */
  count: number;
}

export default function MetricProgress({
  biggest,
  count,
}: IMetricProgressProps) {
  let width = 0;
  if (!isNaN(biggest) && !isNaN(count) && biggest > 0) {
    width = count / biggest;
    if (width > 1) width = 1;
  }
  return (
    <Progress
      className="dbom-video-progress"
      percent={width * 100}
      strokeWidth={6}
      theme={'default'}
    />
  );
}
